import type { DragEventHandler, MouseEventHandler } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Plus } from 'lucide-react'

interface AddSegmentButtonProps {
  canAdd: boolean;
  mutating: boolean;
  draggingOver: boolean;
  onAdd: MouseEventHandler<HTMLButtonElement>;
  onDragOver: DragEventHandler<HTMLButtonElement>;
  onDragLeave: DragEventHandler<HTMLButtonElement>;
  onDrop: DragEventHandler<HTMLButtonElement>;
}

const AddSegmentButton: React.FC<AddSegmentButtonProps> = ({
  canAdd,
  mutating,
  draggingOver,
  onAdd,
  onDragOver,
  onDragLeave,
  onDrop,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        onClick={onAdd}
        disabled={!canAdd || mutating}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className={[
          'flex-shrink-0 flex flex-col items-center justify-center w-[180px] md:w-[204px] xl:w-[220px] min-w-[160px] min-h-[62px] md:min-h-[66px]',
          'rounded-lg border border-dashed text-primary align-stretch px-2 py-1',
          draggingOver ? 'bg-muted/40 shadow-sm border-primary' : 'hover:bg-muted/30',
          'disabled:text-muted-foreground disabled:border-muted-foreground/30',
        ].join(' ')}
        aria-label="添加单元"
      >
        <Plus className="size-8" />
        <span className="text-xs font-semibold whitespace-nowrap">添加单元</span>
      </button>
    </TooltipTrigger>
    <TooltipContent>{canAdd ? '添加单元' : '请选择项目后再添加单元'}</TooltipContent>
  </Tooltip>
)

export default AddSegmentButton;
